import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-evaluate-icon-button',
    templateUrl: './evaluate-icon-button.component.html',
    standalone: false
})
export class EvaluateIconButtonComponent extends AppBaseComponent{
  @Output() triggered = new EventEmitter<void>();

  onClick(): void {
    this.triggered.emit();
  }
}
